<template>
  <div
    class="image"
    v-bind:style="style"
  >
    <slot />

    <DebugTile
      bottom left
      color="yellow"
      v-if="$options.isDebugMode"
      v-bind:data="data"
    />
  </div>
</template>

<script>
import { isDebugMode } from '../../../lib/helpers';

export default {
  name: 'ImageQuestion',

  props: {
    data: Object,
    meta: Object,
  },

  isDebugMode: isDebugMode(),

  computed: {
    style() {
      const style = {};

      if (this.data.background) {
        style.backgroundImage = `url('${this.data.background}')`;
      }

      return style;
    },
  },
};
</script>
